import {useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import usePermissionStatusByKey from './usePermissionStatusByKey';

function useFormPageRedirect({id, createPermissionKey, readPermissionKey, redirectPath = '/settings/profile'}) {
    const history = useHistory();
    const canCreate = usePermissionStatusByKey(createPermissionKey);
    const canRead = usePermissionStatusByKey(readPermissionKey);
    
    useEffect(() => {
        if (id === 'new') {
            if (canCreate === false) {
                history.push(redirectPath);
            }
        } else {
            if (canRead === false) {
                history.push(redirectPath);
            }
        }
    }, [id, canCreate, canRead, history, redirectPath]);

    return {canCreate, canRead};
}

export default useFormPageRedirect;
